import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as ROUTES from "../constants/routes";
import { LANDING_PAGE } from "../constants/routes";
import { updateUser } from "../reducers/userReducer";
import { toggleModal } from "../reducers/modalReducer";
import { setLogout, getRequest, showMessage } from '../config';
import { Menu } from "@mui/icons-material";

export default function NewHeader() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const isPartnerChecklist = location.pathname.startsWith('/partnerChecklist/');
    const isCompleteInvestmentPage = location.pathname.startsWith('/completeInvestment');

    const handleDashboardClick = (e) => {
        if (isCompleteInvestmentPage) { e.preventDefault(); dispatch(toggleModal({ open: 'setPasswordPopup' })); }
        else closeMenu();
    };
    let user = useSelector(state => state.user);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 1200);
    const [activeMenu, setActiveMenu] = useState('');
    const [isActiveBar, setIsActiveBar] = useState(false);
    const [isFloatingBar, setIsFloatingBar] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("token")) {
            getUser();
            checkLogin();
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 1200);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const getUser = async () => {
        let response = await getRequest(`/user`);
        if (response['code'] == 200 && response['body']) {
            user = response['body']['user']
            dispatch(updateUser(user));
        };
    };

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 850) setIsFloatingBar(true);
            else setIsFloatingBar(false);
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    useEffect(() => {
        let path = window.location.pathname;
        if (isFloatingBar) {
            if (path == LANDING_PAGE) setActiveMenu('menu-0');
            else if (path == `${LANDING_PAGE}-accountants`) setActiveMenu('menu-1');
            else if (path == `${LANDING_PAGE}-lawyers`) setActiveMenu('menu-2');
            else if (path == `${LANDING_PAGE}-vcs`) setActiveMenu('menu-3');
            else if (path == `${LANDING_PAGE}-pes`) setActiveMenu('menu-4');
            else if (path == `${LANDING_PAGE}-angel-networks`) setActiveMenu('menu-5');
            else if (path == `${LANDING_PAGE}-angels`) setActiveMenu('menu-6');
            else setActiveMenu('');
        };

        if (path == LANDING_PAGE || path == `${LANDING_PAGE}-accountants` || path == `${LANDING_PAGE}-lawyers` || path == `${LANDING_PAGE}-vcs`
            || path == `${LANDING_PAGE}-pes` || path == `${LANDING_PAGE}-angel-networks` || path == `${LANDING_PAGE}-angels` || path == "/") setIsActiveBar(true);
        else setIsActiveBar(false);

    }, [isFloatingBar]);

    const openMenu = () => {
        document.getElementById("menu").classList.add("showing");
        document.getElementById("menuOverlay").classList.remove("op0", "pen");
    };

    const closeMenu = () => {
        document.getElementById("menu").classList.remove("showing");
        document.getElementById("menuOverlay").classList.add("op0", "pen");
    };

    const checkLogin = async () => await getRequest("/user/checkLogin");
    const handleLoginRegister = () => {
        // if (window.innerWidth < 768) return dispatch(toggleModal({ open: "holdingModal" }));
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        const isMobile = mobileRegex.test(userAgent)
        if (isMobile) {
            return showMessage("You can Login/Register on Laptop")
        }
    };

    const redirectDashbaord = () => {
        if (!user?.['_id']) return;

        // Check if URL has Create Checklist or ResearchAid - redirect to company dashboard
        const urlParams = new URLSearchParams(window.location.search);
        const pathname = window.location.pathname;
        let companyId = urlParams.get('companyId');
        if (companyId && companyId.includes(';')) companyId = companyId.split(';')[0];

        if (pathname.includes('createChecklist') && companyId) return `/company/${companyId}`;
        if (pathname.includes('researchAid/')) {
            const researchAidCompanyId = pathname.split('researchAid/')[1]?.split('?')[0];
            if (researchAidCompanyId) return `/company/${researchAidCompanyId}`;
        }

        if (user['role'] == 'Guest') return ROUTES.REGISTER;
        else if (user['role'] == 'Advisor') return ROUTES.ADVISOR;
        else if (user['role'] == 'Investor') return ROUTES.INVESTOR;
        else return ROUTES.DASHBOARD;
    }

    //TODO: move to redux
    let loggedIn = localStorage.getItem("token") || localStorage.getItem("userId");
    let isClimb26LandingPage = window.location.pathname.includes('climb26') || window.location.pathname.includes('climb')

    return (
        <header className={`bw0px bss pr t0 l0 w100 bg1 ${!isPartnerChecklist && "pt0-5rem pb0-5rem"} new-header ${isClimb26LandingPage ? 'bg15' : 'bg1'}`}
            style={{
                zIndex: 12,
                ...(!isPartnerChecklist && { paddingTop: "8px" })
            }}
        >
            <nav className="container headerContainer wsn df w100 jcsb" style={{ padding: '10px 80px', maxWidth: '100%' }}>
                <div className="df jcsb w100 pr aic">
                    <Link className="df logo-header" to={ROUTES.HOME}>
                        {isClimb26LandingPage
                            ? <img className="py0-5rem h3rem" src={require('../../images/logo_white.png')} alt="logo" />
                            : <img className="py0-5rem h3rem" src={require('../../images/logodiligentsia.svg')} alt="logo" />
                        }
                    </Link>
                    {!isClimb26LandingPage ? <>
                        {!isPartnerChecklist ? <>
                            <div onClick={() => closeMenu()} id="menuOverlay" className="backdrop zi4 cp pen op0 pf t0 l0 w100 h100 td500"></div>
                            <div id="menu" className="c1 c6-xl w100 jce-xl td500 df fdc fdr-xl jcc pf t0 pr-xl wsn menu-safari r0">
                                <div className="df fdc fdr-xl aic">

                                    <Link onClick={() => closeMenu()} className="pt0-5rem pb0-5rem c1 cp pl1rem pr1rem pt0-xl pb0-xl c14-xl brw1px-xl brss-xl bo16-xl fs1rem fw400" to={ROUTES.LANDING_PAGE}>
                                        Companies
                                    </Link>
                                    <Link onClick={() => closeMenu()} className="pt0-5rem pb0-5rem c1 cp pl1rem pr1rem pt0-xl pb0-xl c14-xl brw1px-xl brss-xl bo16-xl fs1rem fw400" to={ROUTES.LANDING_PAGE_FRACTIONAL}>
                                        Fractional
                                    </Link>

                                    <div className="menu-item-with-dropdown brw1px-xl brss-xl bo16-xl pt0-xl pb0-xl pt0-5rem pb0-5rem xl-mah1200px" >
                                        <div className="menu-label c1 cp c14-xl fs1rem fw400">Advisors ▾</div>
                                        <div className="dropdown-content">
                                            <Link className="w100 fs1rem fw400" onClick={() => closeMenu()} to={ROUTES.LANDING_PAGE_FRACTIONAL}>Fractional CFO</Link>
                                            <Link className="w100 fs1rem fw400" onClick={() => closeMenu()} to={ROUTES.LANDING_PAGE_ACCOUNTANT}>Accountants</Link>
                                            <Link className="w100 fs1rem fw400" onClick={() => closeMenu()} to={ROUTES.LANDING_PAGE_LAWYER}>Lawyers</Link>
                                        </div>
                                    </div>

                                    {/* Investors dropdown on hover */}
                                    <div className="menu-item-with-dropdown brw1px-xl brss-xl bo16-xl pt0-xl pb0-xl pt0-5rem pb0-5rem xl-mah1200px">
                                        <div className="menu-label c1 cp c14-xl fs1rem fw400">Investors ▾</div>
                                        <div className="dropdown-content">
                                            <Link className="w100 fs1rem fw400" onClick={() => closeMenu()} to={ROUTES.LANDING_PAGE_VCS}>Venture Capital</Link>
                                            <Link className="w100 fs1rem fw400" onClick={() => closeMenu()} to={ROUTES.LANDING_PAGE_PES}>Private Equity</Link>
                                            <Link className="w100 fs1rem fw400" onClick={() => closeMenu()} to={ROUTES.LANDING_PAGE_ANGEL_NETWORKS}>Angel Networks</Link>
                                            <Link className="w100 fs1rem fw400" onClick={() => closeMenu()} to={ROUTES.LANDING_PAGE_ANGELS}>Angel Investors</Link>
                                        </div>
                                    </div>
                                    <Link onClick={() => closeMenu()} className="pt0-5rem pb0-5rem c1 cp pl1rem pr1rem pt0-xl pb0-xl c14-xl brw1px-xl brss-xl bo16-xl fs1rem fw400" to={ROUTES.PRICING_PLAN}>
                                        Pricing
                                    </Link>
                                    <Link onClick={() => closeMenu()} className="pt0-5rem pb0-5rem c1 cp pl1rem pr1rem pt0-xl pb0-xl c14-xl brw1px-xl brss-xl bo16-xl fs1rem fw400" to={ROUTES.ABOUT_US}>
                                        About Us
                                    </Link>
                                    <Link onClick={() => closeMenu()} className="pt0-5rem pb0-5rem c1 cp pl1rem pr1rem pt0-xl pb0-xl c14-xl fs1rem fw400" to={ROUTES.BLOGS}>
                                        Resources
                                    </Link>

                                </div>
                                <div className="df fdc fdr-xl">
                                    <a href="https://koalendar.com/e/meet-with-mark-bernstein" target="_blank" className="df jcc aic pt0-5rem pb0-5rem c0 cp pl1-5rem pr1-5rem pt0-xl pb0-xl">
                                        <img className="w20px h20px" src={require(`../../images/phone-call.png`)} alt="Call Us" />
                                        <span style={{ marginLeft: '5px' }} className="fw400 fs1rem">Call Us</span>
                                    </a>
                                    {loggedIn
                                        ? user['type'] == 'External'
                                            ? <Link className={`bsbb jcc w200px wa-xl df aic shadow fw500 py0-5rem px1rem br5px my1rem my0-xl mr1rem-xl bg3 c1 cp`} onClick={() => setLogout()}>Logout</Link>
                                            : <>
                                                <Link disabled={user['role'] == 'Guest'} onClick={handleDashboardClick} to={isCompleteInvestmentPage ? '#' : redirectDashbaord()}
                                                    style={{ textDecoration: 'none' }} className={`bsbb jcc w200px wa-xl df aic shadow fw500 py0-5rem px1rem br5px my1rem my0-xl mr1rem-xl ${user['role'] != 'Guest' ? 'bg3 c1 cp' : 'bg16 c2 cna'}`}>
                                                    Dashboard
                                                </Link>
                                                <Link disabled={user['role'] == 'Guest' || localStorage.getItem('isPartnerChecklist') || localStorage.getItem('isDemoChecklist')}
                                                    className={`bsbb jcc w200px wa-xl df aic shadow fw500 py0-5rem px1rem br5px my1rem my0-xl mr1rem-xl ${(user['role'] == 'Guest' || localStorage.getItem('isPartnerChecklist') || localStorage.getItem('isDemoChecklist')) ? 'bg16 c2 cna' : 'bg3 c1 cp'}`}
                                                    onClick={() => { (user['role'] != 'Guest') && setLogout() }}>
                                                    Logout
                                                </Link>
                                            </>
                                        : <>
                                            <Link to={ROUTES.LOGIN} onClick={() => handleLoginRegister()} className="bsbb jcc w200px w9rem df aic fw500 py0-5rem px1rem c1 bg3 br30px my1rem my0-xl cp mr1-5rem-xl xl-h40px">
                                                Login
                                            </Link>
                                            <>
                                                <Link to={ROUTES.REGISTER} onClick={() => { localStorage.removeItem('registerAs'), handleLoginRegister() }} className="bsbb jcc w200px w9rem df fdc aic fw500 px1rem c1 bg4 br30px cp registerButtonAnimation xl-h40px" style={{ width: '70%', paddingTop: '3px', paddingBottom: '3px' }}>
                                                    <span>Register for FREE</span>
                                                    <span className="fw400 c21 df fdc" style={{ marginTop: "-2px", fontSize: '10px', lineHeight: '15px', fontStyle: 'italic' }}>No credit card required</span>
                                                </Link>
                                                {/* <img className='pa t0 r0' src={require('../../images/register-confetti.png')} /> */}
                                            </>
                                        </>
                                    }
                                </div>
                            </div>
                        </> : null
                        }

                        {isMobileView && !isPartnerChecklist && (
                            <Menu onClick={() => openMenu()} className="cp c2" />
                        )}
                    </> : null
                    }
                </div>
            </nav>
            {/* {
                !isClimb26LandingPage ? <>{isActiveBar && isFloatingBar &&
                    <div className='df jcc'>
                        <div className={`mt0-5rem pf br br35px df jcsa aic zi1 w60 p0-5rem mb3rem narBarAnimation`}
                            style={{ left: "15%", width: "65%", zIndex: 11, backgroundColor: 'rgba(103, 117, 185, 0.584)', backdropFilter: 'blur(20px)' }}>
                            {PAGE_MENU_LIST.map((obj, idx) =>
                                <div onClick={() => navigate(obj?.link)} key={obj?.title}
                                    style={{ lineHeight: "30px" }}
                                    className={`cp c1 fs1-2em-screen4 fs1rem-screen1 ${activeMenu == `menu-${idx}` ? 'fw700' : 'fw400'}`}>
                                    {obj?.title}
                                </div>
                            )}
                        </div>
                    </div>
                }</> : null
            } */}

        </header>
    );
}

